import classNames from 'classnames';

import {colors} from 'shells/colors/colors';
import {LeadIconChevron} from 'shells/icon/svg/lead-icon-chevron';
import {getRecipientFromThread, isUnidentifiedRecipient} from 'shells/inbox/helpers';
import {Body} from 'shells/typography/body';

import type {InboxThreadFragment} from 'nutshell-graphql-types';

import {LeadSidebarContent} from './lead-sidebar-content';
import {LeadSidebarHeader} from './lead-sidebar-header';

import styles from './lead-sidebar.module.css';

interface Props {
    isOpen: boolean;
    setIsOpen: (isOpen: boolean) => void;
    isLoadingRelatedLeads: boolean;
    thread?: InboxThreadFragment | null;
}

export function LeadSidebar(props: Props) {
    const leadSidebarClassName = classNames(styles['lead-sidebar'], {
        [styles['lead-sidebar--collapsed']]: !props.isOpen,
    });

    if (!props.thread) {
        return null;
    }

    const recipient = getRecipientFromThread(props.thread);
    const isLeadCreateAllowed = !isUnidentifiedRecipient(recipient.id) && recipient.id !== 'shelly';

    return (
        <div className={leadSidebarClassName}>
            <LeadSidebarHeader
                isOpen={props.isOpen}
                setIsOpen={props.setIsOpen}
                hasLeads={Boolean(props.thread.relatedLeads?.length)}
                isLeadCreateAllowed={isLeadCreateAllowed}
            />
            {props.isOpen &&
                (isLeadCreateAllowed ? (
                    <LeadSidebarContent
                        isLoadingRelatedLeads={props.isLoadingRelatedLeads}
                        thread={props.thread}
                    />
                ) : (
                    <div className='flex flex-dir-col flex-grow pad-16 gap-16 align-center justify-center'>
                        {/* @ts-expect-error */}
                        <LeadIconChevron size={24} wrapWithDiv={false} fill={colors.offWhiteMd} />
                        <Body size='small' color='placeholder' textAlign='center'>
                            The visitor did not share their details and cannot become a lead.
                        </Body>
                    </div>
                ))}
        </div>
    );
}
